import { memo, useCallback } from 'react';

import { Filters } from '@air/next-icons';
import { Button } from '@air/primitive-button';
import { useAirModal } from '@air/provider-modal';

import { CreateSavedFilterModal } from '~/components/SavedFilter/CreateSavedFilterModal';
import { useGetFilterParamsWithTypeFilter } from '~/components/SavedFilter/shared/hooks/useGetFilterParamsWithTypesFilter';

export const PrivateSearchSaveFilterButton = memo(() => {
  const [showCreateSavedFilterModal] = useAirModal(CreateSavedFilterModal);
  const filters = useGetFilterParamsWithTypeFilter();

  const onClick = useCallback(() => {
    showCreateSavedFilterModal({ filters, trackLocation: 'all-content' });
  }, [filters, showCreateSavedFilterModal]);

  return (
    <Button
      appearance="filled"
      color="blue"
      data-testid="SAVED_FILTER_UPDATE_BUTTON"
      onClick={onClick}
      prefix={<Filters className="size-3" />}
      size="small"
    >
      Save filters
    </Button>
  );
});

PrivateSearchSaveFilterButton.displayName = 'PrivateSearchSaveFilterButton';
